import Notifications from "../../slices/notifications/Notifications";

const notificationsReducer = {
    notifications: Notifications,
};

export default notificationsReducer;